import { render, staticRenderFns } from "./hotel.vue?vue&type=template&id=63312885&scoped=true&"
import script from "./hotel.vue?vue&type=script&lang=js&"
export * from "./hotel.vue?vue&type=script&lang=js&"
import style0 from "./hotel.vue?vue&type=style&index=0&id=63312885&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63312885",
  null
  
)

export default component.exports